import React from 'react';
import { Col, Container, Modal, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import ContactTable from '../components/ContactTable';
import type { Contact } from '../types/Contact';

const i18nPrefix = 'ContactTable';

type Props = {
  showModal: boolean;
  hideModal: () => void;
  onSelectContact: (contact: Contact) => void;
};
const ContactListModal = ({ showModal, hideModal, onSelectContact }: Props) => {
  const { t: translate } = useTranslation();

  const onRowDoubleClick = (contact: Contact, arg2: unknown) => {
    console.log('onRowDoubleClick: ', contact, arg2);
    onSelectContact(contact);
  };

  return (
    <Modal animation={false} size='xl' show={showModal} onHide={hideModal}>
      <Modal.Header closeButton>
        <Modal.Title>{translate(`${i18nPrefix}.selectContact`)}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container style={{ maxHeight: 'none' }}>
          <Row>
            <Col sm={9}>
              <h1>{'Kontakte'}</h1>
              <h2>{'Auswählen'}</h2>
            </Col>
          </Row>

          <ContactTable onRowDoubleClick={onRowDoubleClick} />
        </Container>
      </Modal.Body>
    </Modal>
  );
};

export default ContactListModal;
